import { render, staticRenderFns } from "./StickyBottomBanner.vue?vue&type=template&id=021b2e01&scoped=true"
import script from "./StickyBottomBanner.vue?vue&type=script&lang=ts"
export * from "./StickyBottomBanner.vue?vue&type=script&lang=ts"
import style0 from "./StickyBottomBanner.vue?vue&type=style&index=0&id=021b2e01&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021b2e01",
  null
  
)

export default component.exports